import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopicBody"] */ "/vercel/path0/app/components/TopicBody.tsx");
